export default __webpack_public_path__ + "static/media/img10.f574f7ca.png";